import { apiClient } from './apiClient';


export const getStores = async ({ status = '', search = '', page = 0, size = 20 } = {}) => {
  const queryParams = new URLSearchParams();
  if (status) queryParams.append('status', status);
  if (search) queryParams.append('search', search);
  queryParams.append('page', page);
  queryParams.append('size', size);

  return await apiClient(`/admin/management/stores?${queryParams.toString()}`, {
    method: 'GET',
  }, true);
};

export const getStoreById = async (storeId) => {
  if (!storeId) {
    throw new Error('가맹점 ID가 없습니다.');
  }

  return await apiClient(`/admin/management/stores/${storeId}`, {
    method: 'GET',
  }, true);
};

export const approveStore = async (storeId, payload) => {
  if (!storeId) throw new Error('가맹점 ID가 없습니다.');

  return await apiClient(`/admin/management/stores/${storeId}/approve`, {
    method: 'POST',
    body: JSON.stringify(payload),
  }, true);
};
